import React, { Fragment } from "react";

import { Grid, Typography } from "@mui/material";
import {
  miscInstructionsHeader,
  miscInstructionsTexts,
} from "../../../shared/constants/miscinstructions";
import Typographies from "./Typographies";

export default function MiscInstructions() {
  return (
    <Fragment>
      <Grid container justify="center">
        <Grid
          key="tips-instructions"
          xs={12}
          sm={12}
          md={12}
          item
          justifyContent="center"
          alignItems="center"
          marginY={3}
        >
          <Typography align="center" fontSize="h6.fontSize" color="secondary">
            {miscInstructionsHeader}
          </Typography>
          <Typographies typographyData={miscInstructionsTexts} />
        </Grid>
      </Grid>
    </Fragment>
  );
}

MiscInstructions.propTypes = {};
